<template>
  <Authenticated>
    <div class="delivery-zone">
      <h1>Delivery Zone</h1>
      <div class="controls">
        <button class="action-colour" @click="undoLastPoint">Undo Last Point</button>
        <button class="action-colour" @click="resetPoints">Resest Boundary</button>
        <button class="action-colour" @click="saveDeliveryZone()">Save Delivery Zone</button>
        <button class="action-colour" v-if="userAddresses.length > 0" @click="showUsers != showUsers">Show Existing Users</button>
      </div>
      <div v-if="error" class="error-message">
        <p>{{ error }}</p>
      </div>
      <div class="map-container" style="height:600px; width:800px">
        <l-map ref="map" v-model:zoom="zoom" :center="center" @click="addPoint">
          <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" layer-type="base" name="OpenStreetMap"> </l-tile-layer>
          <l-marker :lat-lng="center"></l-marker>
          <l-polygon v-if="points.length > 1" :lat-lngs="polygonPoints" :fill="true" :fill-color="'#3bafda'" :color="'#3bafda'" :weight="3" :opacity="0.65" :fill-opacity="0.35"></l-polygon>
          <l-marker v-for="(address, idx) in userAddresses" :key="idx" :lat-lng="address"></l-marker>
        </l-map>
      </div>
    </div>
  </Authenticated>
</template>

<script>
import Authenticated from "../_layouts/Authenticated.vue";
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker, LPolygon } from "@vue-leaflet/vue-leaflet";
import { mapGetters } from "vuex";
import { api } from "@monolith/helpers";


export default {
  name: "DeliveryZone",
  components: {
    Authenticated,
    LMap,
    LTileLayer,
    LMarker,
    LPolygon,
  },

  data() {
    return {
      zoom: 15,
      center: [-45.8547615, 170.5165676],
      userAddresses: [],
      points: [],
      site: this.$route.params.site,
      error: null,
      showUsers: false,
    };
  },
  computed: {
    ...mapGetters({
      channels: "channels",
      siteSettings: "siteSettings",
      siteMapLoaded: "siteMapLoaded",
    }),
    polygonPoints() {
      return [...this.points, this.points[0]];
    },
  },

  async mounted() {
    let userPoints = await api.get_enduser_points();
    userPoints.forEach((point) => {
      this.userAddresses.push(point)
    })
  },

  methods: {
    checkForDeliveryZone() {
      if (this.siteSettings[this.site].delivery_polygon == null) {
        return;
      }
      let deliveryZone = this.siteSettings[this.site].delivery_polygon;
      if (deliveryZone.length > 0) {
        this.points = deliveryZone;
      }
    },

    addPoint(event) {
      if (event.latlng) {
        let lat = event.latlng.lat;
        let lng = event.latlng.lng;
        this.points.push([lat, lng]);
      }
    },

    undoLastPoint() {
      if (this.points.length > 0) {
        this.points.pop();
      }
    },

    resetPoints() {
      this.points = [];
    },

    saveDeliveryZone() {
      if (this.points == null || this.points.length == 0) {
        this.error = "Add a delivery zone before saving.";
        return;
      }
      let key = "delivery_polygon";
      let insert = this.points;
      // insert.push(insert[0]);
      this.save(key, insert);
    },

    save(s, value) {
      this.channel.push("company:site:setting", { key: s, value: value, site: this.site });
    },
  },

  watch: {
    siteMapLoaded: {
      handler() {
        this.checkForDeliveryZone();
      },
      immediate: true,
    },
  }
};
</script>

<style scoped lang="scss">
.delivery-zone {
  padding: 0 2rem;
}

.controls {
  margin-bottom: 10px;
}

.controls button {
  margin-right: 10px;
  padding: 10px;
  background-color: var(--action-colour);
  color: var(--text-colour);
  cursor: pointer;
}

@media only screen and (orientation: portrait) {

  .controls{
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
}
</style>
